import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Contracts = (store) => ({
  path: ROUTE.CONTRACTS,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'contracts',
    loadReducer: () => import('./ContractsState'),
    loadComponent: () => import('./ContractsContrainer'),
  })
})

export default Contracts
